var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
const millisecond = 1;
const second = 1e3;
const minute = 60 * second;
const hour = 60 * minute;
const day = 24 * hour;
const week = 7 * day;
const month = 30 * day;
const year = 365 * day;
const duration = {
  millisecond,
  second,
  minute,
  hour,
  day,
  week,
  month,
  year
};
class H264Decoder {
  constructor(worker, onReceive, onError) {
    __publicField(this, "worker");
    __publicField(this, "onReceive");
    __publicField(this, "onError");
    __publicField(this, "onReceiveMessage", (event) => {
      const { data } = event;
      if (data.error) {
        const error = new Error(`${data.error}`);
        error.cause = data.error;
        console.warn("H264 worker failure", { error });
        this.onError(data.index);
        return;
      }
      this.onReceive(data);
    });
    var _a;
    this.worker = worker;
    (_a = this.worker) == null ? void 0 : _a.addEventListener("message", this.onReceiveMessage);
    this.onReceive = onReceive;
    this.onError = onError;
  }
  post(timestamp, encodedFrame, flags, index) {
    var _a;
    (_a = this.worker) == null ? void 0 : _a.postMessage({ timestamp, encodedFrame, flags, index });
  }
  release() {
    var _a, _b;
    (_a = this.worker) == null ? void 0 : _a.removeEventListener("message", this.onReceiveMessage);
    (_b = this.worker) == null ? void 0 : _b.terminate();
    this.worker = void 0;
  }
}
class YUVCanvas {
  constructor(gl) {
    __publicField(this, "gl");
    __publicField(this, "program");
    __publicField(this, "texturePosBuffer");
    __publicField(this, "textureRef");
    __publicField(this, "height", 0);
    __publicField(this, "width", 0);
    this.gl = gl;
    this.program = this.initProgram();
    const { texturePosBuffer } = this.initBuffers();
    this.texturePosBuffer = texturePosBuffer;
    const { textureRef } = this.initTextures();
    this.textureRef = textureRef;
  }
  draw(yuv) {
    const { gl, height, width, texturePosBuffer, textureRef } = this;
    gl.viewport(0, 0, width, height);
    const texturePosValues = new Float32Array([1, 0, 0, 0, 1, 1, 0, 1]);
    gl.bindBuffer(gl.ARRAY_BUFFER, texturePosBuffer);
    gl.bufferData(gl.ARRAY_BUFFER, texturePosValues, gl.DYNAMIC_DRAW);
    gl.activeTexture(gl.TEXTURE0);
    gl.bindTexture(gl.TEXTURE_2D, textureRef);
    gl.texImage2D(gl.TEXTURE_2D, 0, gl.LUMINANCE, width, height + height / 2, 0, gl.LUMINANCE, gl.UNSIGNED_BYTE, yuv);
    gl.drawArrays(gl.TRIANGLE_STRIP, 0, 4);
    return gl.getError();
  }
  initProgram() {
    const { gl } = this;
    const vertexShaderScript = `
            attribute vec4 vertexPos;
            attribute vec4 texturePos;
            varying vec2 textureCoord;

            void main() {
                gl_Position = vertexPos;
                textureCoord = texturePos.xy;
            }
        `;
    const fragmentShaderScript = `
            precision highp float;
            varying highp vec2 textureCoord;
            uniform sampler2D yuvSampler;
            uniform mat4 YUV2RGB;

            void main(void) {
                highp vec2 yScale = vec2(1.0, 2.0 / 3.0);
                highp vec2 yTextureCoord = textureCoord * yScale;

                highp vec2 uScale = vec2(0.5, 0.5 / 3.0);
                highp vec2 uOffset = vec2(0.0, 2.0 / 3.0);
                highp vec2 uTextureCoord = (textureCoord * uScale) +  uOffset;

                highp vec2 vScale = vec2(0.5, 0.5 / 3.0);
                highp vec2 vOffset = vec2(0.0, 2.5 / 3.0);
                highp vec2 vTextureCoord = (textureCoord * vScale) +  vOffset;

                highp float y = texture2D(yuvSampler, yTextureCoord).r;
                highp float u = texture2D(yuvSampler, uTextureCoord).r;
                highp float v = texture2D(yuvSampler, vTextureCoord).r;

                gl_FragColor = vec4(y, u, v, 1) * YUV2RGB;
            }
        `;
    const YUV2RGB = [
      1.16438,
      0,
      1.59603,
      -0.87079,
      1.16438,
      -0.39176,
      -0.81297,
      0.52959,
      1.16438,
      2.01723,
      0,
      -1.08139,
      0,
      0,
      0,
      1
    ];
    const vertexShader = gl.createShader(gl.VERTEX_SHADER);
    if (!vertexShader) {
      throw new Error("Failed to create vertex shader");
    }
    gl.shaderSource(vertexShader, vertexShaderScript);
    gl.compileShader(vertexShader);
    const fragmentShader = gl.createShader(gl.FRAGMENT_SHADER);
    if (!fragmentShader) {
      throw new Error("Failed to create fragment shader");
    }
    gl.shaderSource(fragmentShader, fragmentShaderScript);
    gl.compileShader(fragmentShader);
    const program = gl.createProgram();
    if (!program) {
      throw new Error("Failed to create webgl program");
    }
    gl.attachShader(program, vertexShader);
    gl.attachShader(program, fragmentShader);
    gl.linkProgram(program);
    gl.useProgram(program);
    const YUV2RGBRef = gl.getUniformLocation(program, "YUV2RGB");
    gl.uniformMatrix4fv(YUV2RGBRef, false, YUV2RGB);
    return program;
  }
  initBuffers() {
    const { gl, program } = this;
    const vertexPosBuffer = gl.createBuffer();
    gl.bindBuffer(gl.ARRAY_BUFFER, vertexPosBuffer);
    gl.bufferData(gl.ARRAY_BUFFER, new Float32Array([1, 1, -1, 1, 1, -1, -1, -1]), gl.STATIC_DRAW);
    const vertexPosRef = gl.getAttribLocation(program, "vertexPos");
    gl.enableVertexAttribArray(vertexPosRef);
    gl.vertexAttribPointer(vertexPosRef, 2, gl.FLOAT, false, 0, 0);
    const texturePosBuffer = gl.createBuffer();
    if (!texturePosBuffer) {
      throw new Error("Failed to create WebGL buffer");
    }
    gl.bindBuffer(gl.ARRAY_BUFFER, texturePosBuffer);
    gl.bufferData(gl.ARRAY_BUFFER, new Float32Array([1, 0, 0, 0, 1, 1, 0, 1]), gl.STATIC_DRAW);
    const texturePosRef = gl.getAttribLocation(program, "texturePos");
    gl.enableVertexAttribArray(texturePosRef);
    gl.vertexAttribPointer(texturePosRef, 2, gl.FLOAT, false, 0, 0);
    return { texturePosBuffer };
  }
  initTextures() {
    const { gl, program } = this;
    const textureRef = this.initTexture();
    const yuvSamplerRef = gl.getUniformLocation(program, "yuvSampler");
    gl.uniform1i(yuvSamplerRef, 0);
    return { textureRef };
  }
  initTexture() {
    const { gl } = this;
    const textureRef = gl.createTexture();
    if (!textureRef) {
      throw new Error("Failed to initialize texture");
    }
    gl.bindTexture(gl.TEXTURE_2D, textureRef);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.NEAREST);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.NEAREST);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
    gl.bindTexture(gl.TEXTURE_2D, null);
    return textureRef;
  }
}
const decoderNotWorkingThreshold = duration.second * 2.5;
const warnPerformanceThreshold = duration.second / 3;
const noSignalThreshold = duration.second * 2;
const maxQueueSize = 5;
const maxDropRatio = 30 / 25;
const numRetries = 5;
const hardwareIncompatibleErrorCode = 1282;
class H264BytestreamCanvasDrawer {
  constructor(workerFactory, onWebglYUVSupportedChanged, onWarningTextChanged, onCanvasDrawerWarning, trackInfo) {
    __publicField(this, "_waitingForDecoder", true);
    __publicField(this, "_noSignal", true);
    __publicField(this, "_lostSignal", false);
    __publicField(this, "_overWaitingThreshold", false);
    __publicField(this, "_retries", 0);
    __publicField(this, "_webglYUVSupported");
    __publicField(this, "lastDecodedFrameTime");
    __publicField(this, "lastReceivedFrameTime");
    __publicField(this, "lastNoSignalTime", new Date().getTime());
    __publicField(this, "moduleStartTime", Date.now());
    __publicField(this, "moduleCreateTime", Date.now());
    __publicField(this, "timesRestarted", 0);
    __publicField(this, "canvas");
    __publicField(this, "decoder");
    __publicField(this, "yuvCanvas");
    __publicField(this, "webglContext");
    __publicField(this, "frameQueue", []);
    __publicField(this, "minFrameSize", Infinity);
    __publicField(this, "maxFrameSize", 0);
    __publicField(this, "decoderQueue", []);
    __publicField(this, "decoderQueueLocked", false);
    __publicField(this, "decodeNextFrameAttempted", false);
    __publicField(this, "numFramesDecoded", 0);
    __publicField(this, "numFramesReceived", 0);
    __publicField(this, "hasReceivedKeyframe", false);
    __publicField(this, "medianFrameSize", 0);
    __publicField(this, "currentFrameIndex");
    __publicField(this, "frameCheckpointMap", new Map());
    __publicField(this, "lastDrawnFrameTime");
    __publicField(this, "minJitter");
    __publicField(this, "maxJitter");
    __publicField(this, "start", () => {
      const { canvas } = this;
      if (!canvas) {
        return;
      }
      const webglContext = canvas.getContext("webgl");
      this.webglContext = webglContext || void 0;
      this.lastDecodedFrameTime = void 0;
      this.lastReceivedFrameTime = void 0;
      this.hasReceivedKeyframe = false;
      this.currentFrameIndex = void 0;
      if (!this.canvas || !this.webglContext) {
        return;
      }
      if (!this.yuvCanvas) {
        this.yuvCanvas = new YUVCanvas(this.webglContext);
      }
      this.moduleStartTime = Date.now();
    });
    __publicField(this, "stop", () => {
      var _a;
      (_a = this.decoder) == null ? void 0 : _a.release();
      this.webglContext = void 0;
      this.decoderQueueLocked = false;
    });
    __publicField(this, "reset", () => {
      this.retries = 0;
      this.restart();
    });
    __publicField(this, "notifyWarningTextChanged", () => {
      var _a;
      (_a = this.onWarningTextChanged) == null ? void 0 : _a.call(this, this.getWarningText());
    });
    __publicField(this, "restart", () => {
      console.info("Restarting decoder");
      console.info("BytestreamPlayer restarting", __spreadProps(__spreadValues({}, this.trackInfo), {
        Restart: this.timesRestarted
      }));
      this.frameQueue = [];
      this.decoderQueue = [];
      this.stop();
      this.decoder = new H264Decoder(this.workerFactory(), this.onReceiveDecodedFrame, this.onDecoderError);
      this.start();
      this.retries++;
      this.timesRestarted++;
    });
    __publicField(this, "onTrackTick", () => {
      if (this.numFramesDecoded === 0) {
        if (this.lastDecodedFrameTime === void 0) {
          const now = Date.now();
          console.info("BytestreamPlayer waiting for video", __spreadProps(__spreadValues({}, this.trackInfo), {
            "Time Waited": now - this.moduleCreateTime
          }));
        }
        return;
      }
      const dropRatio = this.numFramesReceived / this.numFramesDecoded;
      if (dropRatio > maxDropRatio) {
        this.warnPerformanceProblems();
      }
      this.numFramesReceived = 0;
      this.numFramesDecoded = 0;
      const oldFrameStateMap = Array.from(this.frameCheckpointMap.entries()).reduce((acc, [key, value]) => {
        var _a;
        if (!this.currentFrameIndex || key > this.currentFrameIndex - 60) {
          return acc;
        }
        if (value === "FrameDrawn") {
          return acc;
        }
        acc[value] = ((_a = acc[value]) != null ? _a : 0) + 1;
        this.frameCheckpointMap.delete(key);
        return acc;
      }, {});
      Object.keys(oldFrameStateMap).map((key) => {
        console.info("BytestreamPlayer Frame Dropped", __spreadProps(__spreadValues({}, this.trackInfo), {
          "Num Dropped": oldFrameStateMap[key],
          "Frame State": key
        }));
      });
      const { minJitter, maxJitter } = this;
      if (minJitter && maxJitter) {
        console.info("BytestreamPlayer Jitter", __spreadProps(__spreadValues({}, this.trackInfo), {
          minJitter,
          maxJitter
        }));
        this.minJitter = void 0;
        this.maxJitter = void 0;
      }
    });
    __publicField(this, "onTick", () => {
      var _a;
      const {
        lastReceivedFrameTime,
        lastDecodedFrameTime,
        moduleStartTime,
        noSignal,
        retries
      } = this;
      const time = new Date().getTime();
      if (noSignal) {
        this.lastNoSignalTime = time;
      }
      this.overWaitingThreshold = time - moduleStartTime > noSignalThreshold;
      const overDecoderThreshold = time - moduleStartTime > decoderNotWorkingThreshold;
      if (!lastDecodedFrameTime) {
        if (lastReceivedFrameTime && overDecoderThreshold && retries < numRetries) {
          this.waitingForDecoder = true;
          this.restart();
        }
        return;
      }
      if (lastReceivedFrameTime) {
        const receivedDiff = time - lastReceivedFrameTime;
        const decodedDiff = time - lastDecodedFrameTime;
        const noSignalDiff = time - this.lastNoSignalTime;
        if (noSignalDiff > noSignalThreshold && receivedDiff < warnPerformanceThreshold && decodedDiff > warnPerformanceThreshold) {
          this.warnPerformanceProblems();
        }
        if (receivedDiff > noSignalThreshold) {
          this.lostSignal = true;
        }
      }
      if (this.overWaitingThreshold && (this.waitingForDecoder || this.noSignal || this.lostSignal)) {
        (_a = this.onCanvasDrawerWarning) == null ? void 0 : _a.call(this, "ShouldDisableControl");
      }
    });
    __publicField(this, "receiveEncodedFrame", (frame) => {
      if (!frame) {
        return;
      }
      const index = frame.index;
      if (index) {
        this.frameCheckpointMap.set(index, "FrameReceived");
      }
      if (!frame || !this.canvas || !this.webglContext) {
        return;
      }
      this.isKeyframe(frame);
      if (!this.hasReceivedKeyframe) {
        console.info("Dropping frame because no keyframe detected");
        return false;
      }
      if (this.lastReceivedFrameTime === void 0) {
        console.debug("Received first frame on bytestream player", __spreadValues({}, this.trackInfo));
      }
      this.checkOrder(frame);
      this.numFramesReceived++;
      this.lastReceivedFrameTime = Date.now();
      if (this.lostSignal) {
        this.restart();
      }
      this.noSignal = false;
      this.lostSignal = false;
      this.frameQueue.push(frame);
      if (index) {
        this.frameCheckpointMap.set(index, "FrameQueued");
      }
      if (this.frameQueue.length > maxQueueSize) {
        this.frameQueue = this.frameQueue.filter((_) => this.isKeyframe(_));
      }
      if (this.frameQueue.length > maxQueueSize) {
        this.frameQueue = [];
        this.decoderQueue = [];
      }
      this.decodeNextFrame();
    });
    __publicField(this, "onDecoderError", (index) => {
      this.frameQueue = [];
      this.decoderQueue = [];
      this.hasReceivedKeyframe = false;
      console.info("BytestreamPlayer decode error", __spreadProps(__spreadValues({}, this.trackInfo), {
        "Frame Index": index
      }));
    });
    __publicField(this, "onReceiveDecodedFrame", (data) => {
      var _a, _b;
      const { canvas, yuvCanvas, decoderQueue } = this;
      const { timestamp, yuv, height, width, index } = data;
      this.frameCheckpointMap.set(index, "FrameDecoded");
      this.numFramesDecoded++;
      const now = Date.now();
      if (this.lastDecodedFrameTime === void 0) {
        console.info("BytestreamPlayer started video", __spreadProps(__spreadValues({}, this.trackInfo), {
          "Time Until Video": now - this.moduleCreateTime
        }));
      }
      this.lastDecodedFrameTime = now;
      this.waitingForDecoder = false;
      this.decoderQueue = decoderQueue.filter((_) => now - _ < duration.second * 0.5 && _ !== timestamp);
      if (!decoderQueue.includes(timestamp) || now - timestamp > duration.second || !yuvCanvas || !canvas || height === 0 || width === 0) {
        return;
      }
      if (height !== canvas.height) {
        canvas.height = height;
        yuvCanvas.height = height;
      }
      if (width !== canvas.width) {
        canvas.width = width;
        yuvCanvas.width = width;
      }
      const error = yuvCanvas.draw(yuv);
      const drawTime = Date.now();
      if (this.lastDrawnFrameTime) {
        const drawTimeDiff = drawTime - this.lastDrawnFrameTime;
        this.minJitter = Math.min(drawTimeDiff, (_a = this.minJitter) != null ? _a : Number.MAX_SAFE_INTEGER);
        this.maxJitter = Math.max(drawTimeDiff, (_b = this.maxJitter) != null ? _b : 0);
      }
      this.lastDrawnFrameTime = drawTime;
      this.frameCheckpointMap.set(index, "FrameDrawn");
      if (error === 0) {
        this.webglYUVSupported = true;
      }
      if (error === hardwareIncompatibleErrorCode) {
        this.webglYUVSupported = false;
      }
      if (this.frameQueue.length > 0) {
        this.decodeNextFrame();
      }
    });
    this.workerFactory = workerFactory;
    this.onWebglYUVSupportedChanged = onWebglYUVSupportedChanged;
    this.onWarningTextChanged = onWarningTextChanged;
    this.onCanvasDrawerWarning = onCanvasDrawerWarning;
    this.trackInfo = trackInfo;
    this.decoder = new H264Decoder(this.workerFactory(), this.onReceiveDecodedFrame, this.onDecoderError);
    setInterval(this.onTick, duration.millisecond * 200);
    setInterval(this.onTrackTick, duration.second * 5);
  }
  get waitingForDecoder() {
    return this._waitingForDecoder;
  }
  set waitingForDecoder(value) {
    this._waitingForDecoder = value;
    this.notifyWarningTextChanged();
  }
  get noSignal() {
    return this._noSignal;
  }
  set noSignal(value) {
    this._noSignal = value;
    this.notifyWarningTextChanged();
  }
  get lostSignal() {
    return this._lostSignal;
  }
  set lostSignal(value) {
    this._lostSignal = value;
    this.notifyWarningTextChanged();
  }
  get overWaitingThreshold() {
    return this._overWaitingThreshold;
  }
  set overWaitingThreshold(value) {
    this._overWaitingThreshold = value;
    this.notifyWarningTextChanged();
  }
  get retries() {
    return this._retries;
  }
  set retries(value) {
    this._retries = value;
    this.notifyWarningTextChanged();
  }
  get webglYUVSupported() {
    return this._webglYUVSupported;
  }
  set webglYUVSupported(value) {
    var _a;
    this._webglYUVSupported = value;
    (_a = this.onWebglYUVSupportedChanged) == null ? void 0 : _a.call(this, value);
    this.notifyWarningTextChanged();
  }
  setCanvas(canvas) {
    this.canvas = canvas;
  }
  getWarningText() {
    var _a;
    const {
      waitingForDecoder,
      noSignal,
      overWaitingThreshold,
      lostSignal,
      retries,
      webglYUVSupported
    } = this;
    const notSupported = webglYUVSupported === false;
    const showReloadButton = retries === numRetries;
    const decoderNotWorkingLabel = waitingForDecoder ? showReloadButton ? "Decoder failed to start" : "Starting decoder" : void 0;
    const incompatibleLabel = notSupported ? "Hardware decoding not supported on this device" : void 0;
    const noSignalLabel = lostSignal ? "Lost signal" : noSignal ? overWaitingThreshold ? "No signal" : "Waiting for signal" : void 0;
    const noVideoLabel = (_a = incompatibleLabel != null ? incompatibleLabel : noSignalLabel) != null ? _a : decoderNotWorkingLabel;
    return noVideoLabel;
  }
  decodeNextFrame() {
    if (this.decoderQueueLocked) {
      this.decodeNextFrameAttempted = true;
    }
    this.decoderQueueLocked = true;
    if (this.decoderQueue.length > maxQueueSize) {
      this.decoderQueueLocked = false;
      this.decodeNextFrameAttempted = false;
      return;
    }
    const frame = this.frameQueue.shift();
    if (!frame) {
      this.decoderQueueLocked = false;
      this.decodeNextFrameAttempted = false;
      return;
    }
    const now = Date.now();
    this.frameCheckpointMap.set(frame.index, "FrameSentToDecoder");
    this.decoder.post(now, frame.frame_data, frame.flags, frame.index);
    this.decoderQueue.push(now);
    this.decoderQueueLocked = false;
    if (this.decodeNextFrameAttempted) {
      this.decodeNextFrameAttempted = false;
      this.decodeNextFrame();
    }
  }
  warnPerformanceProblems() {
    var _a;
    if (this.lastDecodedFrameTime && this.overWaitingThreshold && !this.lostSignal && !this.noSignal) {
      (_a = this.onCanvasDrawerWarning) == null ? void 0 : _a.call(this, "ShouldDegradeVideo");
    }
  }
  checkOrder(payload) {
    if (this.currentFrameIndex !== void 0) {
      if (payload.index < this.currentFrameIndex) {
        console.info("Out of order frame detected");
        console.info("Frame out of order", __spreadValues({}, this.trackInfo));
        return;
      }
    }
    this.currentFrameIndex = payload.index;
  }
  isKeyframe(payload) {
    const { maxFrameSize, minFrameSize } = this;
    if (payload.flags === 3) {
      if (!this.hasReceivedKeyframe) {
        this.frameCheckpointMap = new Map();
      }
      this.hasReceivedKeyframe = true;
      return true;
    }
    const frameSize = payload.frame_data.length;
    this.maxFrameSize = Math.max(frameSize, maxFrameSize);
    this.minFrameSize = Math.min(frameSize, minFrameSize);
    this.medianFrameSize = (this.maxFrameSize + this.minFrameSize) / 2;
    if (this.moduleStartTime + duration.second * 2 > Date.now()) {
      return false;
    }
    if (frameSize > this.medianFrameSize) {
      this.hasReceivedKeyframe = true;
      return true;
    }
    return false;
  }
}
export { H264BytestreamCanvasDrawer };
